// Barra de herramientas con íconos (la de Random, bajo el menú): cada ícono es un SUBSISTEMA. Elegirlo
// cambia el menú de texto de arriba, que pasa a mostrar los menús de ese subsistema (Ventas →
// Negocios · Punto de Venta · Documentos…). Inicio vuelve al escritorio. A la derecha, los accesos
// rápidos fijados con ☆. Como el menú, NO crea pestañas.
import { Icono } from '../comun/Icono';
import { BarraAccesos } from './BarraAccesos';
import type { Modulo, Pantalla } from './navegacion';

const ICONOS: Record<string, string> = {
  ventas: 'ventas',
  compras: 'compras',
  stock: 'stock',
  operaciones: 'operaciones',
  cobros: 'cobros',
  pagos: 'pagos',
  dte: 'dte',
  informes: 'informes',
  gerencia: 'gerencia',
  configuracion: 'configuracion',
};

/** Grupos separados por una línea, como los de Random. */
const GRUPOS = [
  ['ventas', 'compras', 'stock', 'operaciones'],
  ['cobros', 'pagos'],
  ['dte', 'informes', 'gerencia', 'configuracion'],
];

export function BarraHerramientas({
  modulos,
  subsistema,
  enInicio,
  nombresCortos,
  favoritos,
  visible,
  alInicio,
  alElegirSubsistema,
  alElegir,
}: {
  /** Los módulos que el usuario puede ver (ya filtrados por permisos). */
  modulos: Modulo[];
  subsistema: string | null;
  enInicio: boolean;
  nombresCortos: boolean;
  favoritos: string[];
  visible: (p: Pantalla) => boolean;
  alInicio: () => void;
  alElegirSubsistema: (id: string) => void;
  alElegir: (p: Pantalla) => void;
}) {
  const grupos = GRUPOS.map((g) => g.flatMap((id) => modulos.filter((m) => m.id === id))).filter(
    (g) => g.length,
  );

  return (
    <div className="barra-herramientas">
      <div className="herramientas" role="toolbar" aria-label="Barra de herramientas">
        <div className="grupo-herramientas">
          <button
            type="button"
            className={`herramienta${enInicio ? ' actual' : ''}`}
            data-herramienta="inicio"
            title="Inicio (escritorio)"
            onClick={alInicio}
          >
            <Icono nombre="inicio" tamano={24} />
            <span className="rotulo">Inicio</span>
          </button>
        </div>
        {grupos.map((g, i) => (
          <div key={i} className="grupo-herramientas">
            {g.map((m) => (
              <button
                key={m.id}
                type="button"
                className={`herramienta${subsistema === m.id ? ' elegido' : ''}`}
                data-herramienta={m.id}
                title={m.nombre}
                aria-pressed={subsistema === m.id}
                onClick={() => alElegirSubsistema(m.id)}
              >
                <Icono nombre={ICONOS[m.id] ?? 'mas'} tamano={24} />
                <span className="rotulo">{nombresCortos ? m.corto : m.nombre}</span>
              </button>
            ))}
          </div>
        ))}
      </div>
      <BarraAccesos favoritos={favoritos} visible={visible} alElegir={alElegir} />
    </div>
  );
}
